import { formatSales, getSalesSummaryByHosting } from "./SalesReports.utils";

const getSalesReportBody = (appsSales = []) => appsSales.map(appSale => {
  const salesByHosting = getSalesSummaryByHosting(appSale);
  return {
    key: appSale.addonKey,
    cells: [{
      key: appSale.name,
      content: appSale.name
    }, {
      key: salesByHosting.cloud.revenue,
      content: formatSales(salesByHosting.cloud)
    }, {
      key: salesByHosting.server.revenue,
      content: formatSales(salesByHosting.server)
    }, {
      key: salesByHosting.datacenter.revenue,
      content: formatSales(salesByHosting.datacenter)
    }, {
      key: salesByHosting.total.revenue,
      content: formatSales(salesByHosting.total)
    }]
  };
});

export default getSalesReportBody;